import React from "react";
import ranjit from '../../Assets/Images/ranjitsingh.webp'
import biswajit from '../../Assets/Images/biswajitjena.webp'
import monika from '../../Assets/Images/monika.webp'

const OurTeam = () => {
  return (
    <div className="my-8  pb-8 sm:pb-12 md:pb-16 lg:pb-20 ">
      <div className="">
        {/* Header Section */}
        <div className="text-center mb-8 sm:mb-12 md:mb-16 lg:mb-20">
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-gray-900 mb-4 sm:mb-6 md:mb-8">
            Our <span className="text-[#FF6B35]">Team</span>
          </h1>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed text-justify mx-auto px-4">
            At Covenants Real Estate, our success is driven by a dedicated team
            of professionals who are passionate about real estate and committed
            to providing exceptional service. Our team brings together diverse
            expertise in property development, sales, marketing, and customer
            relations to deliver outstanding results for our clients. Get to
            know the people behind our success and discover how their unique
            skills and experience contribute to making Covenants Real Estate a
            trusted name in the industry.
          </p>
        </div>

        {/* Team Members Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 md:gap-10 lg:gap-12">
          {/* Team Member 1 - Deba Prasad Pattanaik */}
          <div className="text-center sm:col-span-2 lg:col-span-1 sm:mx-auto lg:mx-0 max-w-sm sm:max-w-none">
            <div className="bg-white rounded-md sm:rounded-lg overflow-hidden shadow-lg mb-4 sm:mb-6 aspect-[3/4] sm:aspect-[4/5]">
              <img
                src={monika}
                alt="Monika Chauhan"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 mb-1 sm:mb-2">
              Monika Chauhan
            </h3>
            <p className="text-gray-600 text-sm sm:text-base">
              Director
            </p>
          </div>
          
          {/* Team Member 2 - Bishnu Priya Mangaraj */}
          <div className="text-center">
            <div className="bg-white rounded-md sm:rounded-lg overflow-hidden shadow-lg mb-4 sm:mb-6 aspect-[3/4] sm:aspect-[4/5]">
              <img
                src={biswajit}
                alt="Biswajit Jena"
                className="w-full h-f object-cover"
              />
            </div>
            <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 mb-1 sm:mb-2">
              Biswajit Jena
            </h3>
            <p className="text-gray-600 text-sm sm:text-base">Asst. General Manager</p>
          </div>

          {/* Team Member 3 - Prabati Kumar Rath */}
          <div className="text-center">
            <div className="bg-white rounded-md sm:rounded-lg overflow-hidden shadow-lg mb-4 sm:mb-6 aspect-[3/4] sm:aspect-[4/5]">
              <img
                src={ranjit}
                alt="Ranjit Singh"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 mb-1 sm:mb-2">
              Ranjit Singh
            </h3>
            <p className="text-gray-600 text-sm sm:text-base">Finance Head</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
